import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';

const sizeClassMapper: Record<'xsmall' | 'small' | 'medium' | 'large', string> =
  {
    xsmall: 'w-6 h-6 text-[9px] leading-[9px]',
    small: 'w-9 h-9 text-[15px] leading-[15px]',
    medium: 'w-14 h-14 text-[24px] leading-[24px]',
    large: 'w-24 h-24 text-[34px] leading-[34px]',
  };

@Component({
  selector: 'abb-avatar',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if(userImgUrl()) {
    <div class="mx-2 pt-4 inline-flex flex-row items-center justify-center">
      <div
        class="rounded-full bg-abb-background bg-center bg-cover"
        [ngClass]="[!!userImgUrl() ? 'shadow-xl' : '', sizeCls()]"
        [ngStyle]="{ backgroundImage: 'url(' + userImgUrl() + ')' }"
      ></div>
    </div>
    } @else {
    <div
      class="inline-flex flex-row items-center justify-center"
      [ngClass]="{
        'mx-2 py-2':
          ['small', 'medium', 'large'].includes(size()) &&
          customSize() == undefined
      }"
    >
      <div
        class="rounded-full bg-abb-gray-02 text-abb-white content-center text-center cursor-default"
        [ngClass]="sizeCls()"
      >
        {{ userBadgeLabel() }}
      </div>
    </div>
    }
  `,
  styles: ``,
})
export class AbbAvatarComponent {
  size = input<'xsmall' | 'small' | 'medium' | 'large'>('large');
  customSize = input<string | undefined>(undefined);
  userFullName = input<string>('');
  userImgUrl = input<string | undefined>(undefined);
  userBadgeLabel = computed(() =>
    this.userFullName()
      ?.split(' ')
      ?.map((w: string) => w[0]?.toUpperCase())
      .join('')
  );
  sizeCls = computed(() => this.customSize() ?? sizeClassMapper[this.size()]);
}
